import ExcelDownload from "../ExcelDownload";
import { AddButton, SearchToggleButton } from "./Button";
import { AutoCompletes, DateInput } from "./custominput";
import { Autocomplete, TextField } from "@mui/material";

export const DISBURSEMENT_OPTIONS = [
  { label: "Pending", value: 0 },
  { label: "Disbursed", value: 1 },
  { label: "Partially Disbursed", value: 2 },
];

export default function ListSearchSection({
  title = "Search",
  fields = [],
  onSearch,
  dateFilterShow = false,
  searchKey,
  setSearchKey,
  searchBy,
  setSearchBy,
  clearSearch,
  searched,
  setSearched,
  showExcelDownload = false,
  finalData = [],
  notNeededColumn = [],
  extraButton = false,
  extraButtonLable = "",
  onJobAssignClick,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  requiredReport = false, // new prop
  subTypeOptions = [], // new prop
  reportFilters, // new prop  { subTypes: [], disbursementStatus: [] }
  setReportFilters, // new prop
  jobAssignShow = false,
}) {
  const _userType = Number(localStorage.getItem("type"));

  return (
    <div className="mt-2 border border-blue-100 rounded-xl shadow-sm p-6 pt-3 mb-4 bg-white">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end md:grid grid-cols-2 lg:grid-cols-5 md:gap-4 lg:gap-4 w-full">
        {/* Select Field */}
        <div className="flex-1">
          <label
            htmlFor="search-field"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Search by
          </label>
          <AutoCompletes
            id="search-field"
            label={"Select field"}
            options={fields}
            value={searchBy}
            onChange={(e) => {
              setSearchBy(e);
              setSearched(false);
            }}
          />
        </div>

        {/* Input Value */}
        <div className="flex-1">
          <label
            htmlFor="search-value"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Search value
          </label>
          <input
            type="text"
            id="search-value"
            value={searchKey}
            onChange={(e) => setSearchKey(e.target.value)}
            onKeyDown={(e) => {
              e.key === "Enter" && onSearch();
              setSearched(false);
            }}
            placeholder="Enter search term"
            className="w-full border border-blue-200 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Date Filters */}
        {dateFilterShow && (
          <>
            <div className="flex-1">
              <DateInput
                id="from-date"
                label="From Date"
                value={fromDate}
                onChange={(newValue) => {
                  setFromDate(newValue);
                  setSearched(false);
                }}
              />
            </div>
            <div className="flex-1">
              <DateInput
                id="to-date"
                label="To Date"
                value={toDate}
                onChange={(newValue) => {
                  setToDate(newValue);
                  setSearched(false);
                }}
              />
            </div>
          </>
        )}

        {/* Report Filters */}
        {requiredReport && (
          <>
            {/* Sub Types */}
            <div className="flex-1">
              <Autocomplete
                multiple
                size="small"
                options={subTypeOptions}
                value={reportFilters?.subTypes || []}
                onChange={(_, newValue) => {
                  setReportFilters((prev) => ({ ...prev, subTypes: newValue }));
                  setSearched(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sub Types"
                    placeholder="Select subtype"
                  />
                )}
              />
            </div>

            {/* Disbursement Status */}
            <div className="flex-1">
              <Autocomplete
                multiple
                size="small"
                options={DISBURSEMENT_OPTIONS}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                value={reportFilters?.disbursementStatus || []}
                onChange={(_, newValue) => {
                  setReportFilters((prev) => ({
                    ...prev,
                    disbursementStatus: newValue,
                  }));
                  setSearched(false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Disbursement Status"
                    placeholder="Select status"
                  />
                )}
              />
            </div>
          </>
        )}

        {/* Action Buttons */}
        <div className="sm:mt-0 w-full sm:w-auto flex gap-4">
          <SearchToggleButton
            searched={searched}
            onSearch={onSearch}
            onClear={clearSearch}
          />

          {showExcelDownload && (
            <div className="min-w-[140px]">
              <ExcelDownload
                finalData={finalData}
                notNeededColumn={notNeededColumn}
              />
            </div>
          )}

          {extraButton && jobAssignShow && (
            <AddButton
              className="w-auto min-w-[180px]"
              id={`btn-${extraButtonLable}`}
              label={extraButtonLable}
              onClick={onJobAssignClick}
            />
          )}
        </div>
      </div>
    </div>
  );
}
